import { motion } from 'framer-motion';

const ProductSkeleton = () => {
  return (
    <div className="product-skeleton">
      <div className="product-skeleton__image">
        <motion.div
          className="product-skeleton__shimmer"
          animate={{ x: [-100, 100] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: 'linear' }}
        />
      </div>
      <div className="product-skeleton__content">
        <div className="product-skeleton__title">
          <motion.div
            className="product-skeleton__shimmer"
            animate={{ x: [-100, 100] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: 'linear', delay: 0.1 }}
          />
        </div>
        <div className="product-skeleton__price">
          <motion.div
            className="product-skeleton__shimmer"
            animate={{ x: [-100, 100] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: 'linear', delay: 0.2 }}
          />
        </div>
        <div className="product-skeleton__category">
          <motion.div
            className="product-skeleton__shimmer"
            animate={{ x: [-100, 100] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: 'linear', delay: 0.3 }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductSkeleton;